import { createSlice } from "@reduxjs/toolkit";
import { postRequest } from "../../services/apiCaller/cl_index";
import {
  getFromLocalStorage,
  setToLocalStorage,
  removeFromLocalStorage,
  trackEvent,
} from "../../services/helper/cl_Helper";
import { endpoints } from "../../api/ApiEndPoints";
import { setToken } from "../signUp/cl_SignUpSlice";
import { handleLogout } from "../changePin/cl_ChangePinSlice";
import {
  subscribeUserBalance,
  unSubscribeUserBalance,
} from "../../services/socket/cl_index";
import { setIsmodalOpen } from "../home/cl_LoyalltyCoins";
import {
  trackBonusClaimEvent,
  trackLoginSuccessEvent,
} from "../../service/gtag";

const initialState = {
  phoneNumber: "",
  countryCode: "",
  age: "",
  signInSuccess: false,
  errorMessage: "",
  phoneError: false,
  pinError: false,
  otpSuccess: false,
  resendOtp: false,
  fullName: "",
  pin: "",
  confirmPin: "",
  isLoading: false,
  mobileLoader: false,
  referralCode: "",
  countryCode: "",
  token: "",
  phoneNumberChange: false,
  userDetails: {},
  playerDetails: {},
  balance: "",
  activeItem: 0,
  balanceDetails: {},
  sessionActive: false,
  IsSearchBoxOpen: false,
  searchCtg: false,
  updateLoyalty: false,
  userLoyalty: {},
  burnCoins: 0,
  lifeTimeBurns: [],
  lifeTimeCashBack: [],
  IsVipSearchBoxOpen: false,
  selectedGames: [],
  crashGames: false,
  configApiDetails: [],
  isApiCall: false,
  homePopUp: false,
  selfexclusion: {},
  selfexclusionError: "",
};

export const signInSlice = createSlice({
  name: "signin",
  initialState,
  reducers: {
    setPhoneNumber: (state, action) => {
      state.phoneNumber = action.payload;
    },
    setConfigApiDetails: (state, action) => {
      state.configApiDetails = action.payload;
    },
    setUpdateLoyalty: (state, action) => {
      state.updateLoyalty = action.payload;
    },
    setCrashGames: (state, action) => {
      state.crashGames = action.payload;
    },
    setUserLoyalty: (state, action) => {
      state.userLoyalty = action.payload;
    },
    setBalanceDetails: (state, action) => {
      state.balanceDetails = action.payload;
    },
    setSignInSuccess: (state, action) => {
      state.signInSuccess = action.payload;
    },
    setErrorMessage: (state, action) => {
      state.errorMessage = action.payload;
    },
    setPhoneError: (state, action) => {
      state.phoneError = action.payload;
    },
    setPinError: (state, action) => {
      state.pinError = action.payload;
    },
    setPin: (state, action) => {
      state.pin = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setMobileLoader: (state, action) => {
      state.mobileLoader = action.payload;
    },
    setPhoneNumberChange: (state, action) => {
      state.phoneNumberChange = action.payload;
    },
    setUserDetails: (state, action) => {
      state.userDetails = action.payload;
    },
    setPlayerDetails: (state, action) => {
      state.playerDetails = action.payload;
    },
    setBalance: (state, action) => {
      state.balance = action.payload;
    },
    setActiveItem: (state, action) => {
      state.activeItem = action.payload;
    },
    setSessionActive: (state, action) => {
      state.sessionActive = action.payload;
    },
    setSearchCtg: (state, action) => {
      state.searchCtg = action.payload;
    },
    setIsSearchBoxOpen: (state, action) => {
      state.IsSearchBoxOpen = action.payload;
    },
    setBurnCoinsData: (state, action) => {
      state.burnCoins = action.payload;
    },
    setLifeTimeBurns: (state, action) => {
      state.lifeTimeBurns = action.payload;
    },
    setLifeTimeCashBack: (state, action) => {
      state.lifeTimeCashBack = action.payload;
    },
    setIsVipSearchBoxOpen: (state, action) => {
      state.IsVipSearchBoxOpen = action.payload;
    },
    setIsApiCall: (state, action) => {
      state.isApiCall = action.payload;
    },
    setSelfExclusion: (state, action) => {
      state.selfexclusion = action.payload;
    },
    setSelfExclusionError: (state, action) => {
      state.selfexclusionError = action.payload;
    },
    // setHomePopUp: (state, action) => {
    //   state.homePopUp = action.payload;
    // },
  },
});

export const {
  setPhoneNumber,
  setSignInSuccess,
  setErrorMessage,
  setSignUpfinish,
  setPhoneError,
  setPinError,
  setPin,
  setIsLoading,
  setMobileLoader,
  setPhoneNumberChange,
  setAge,
  setUserDetails,
  setPlayerDetails,
  setBalance,
  setActiveItem,
  setBalanceDetails,
  setSessionActive,
  setIsSearchBoxOpen,
  setSearchCtg,
  setUpdateLoyalty,
  setUserLoyalty,
  setBurnCoinsData,
  setLifeTimeBurns,
  setLifeTimeCashBack,
  setIsVipSearchBoxOpen,
  setSelectedGames,
  setCrashGames,
  setConfigApiDetails,
  setIsApiCall,
  setSelfExclusion,
  setSelfExclusionError,
  // setHomePopUp,
} = signInSlice.actions;

export default signInSlice.reducer;

export const handleSignIn = (mobNum, pin, navigate, from) => (dispatch) => {
  dispatch(setIsLoading(true));
  let url = endpoints?.signIn;
  let phoneNum = mobNum;
  if (mobNum[0] === "0") {
    phoneNum = mobNum.slice(1);
  }
  const payload = {
    channelType: "mobile",
    isUserdetailsRequired: true,
    mobileNumber: phoneNum,
    password: pin,
  };
  postRequest(url, payload)
    .then((res) => {
      if (res?.data?.code === "1000") {
        dispatch(setIsLoading(false));
        dispatch(setSignInSuccess(true));
        const playerDetails =
          res?.data?.result?.player_details?.userOtherInfo?.phone;
        const userId = playerDetails;
        const userType = playerDetails?.is_first_login ? "new" : "returning";
        trackLoginSuccessEvent(userId, userType, "success");

         if (from === "signup") {
          const loyaltyUserId = res?.data?.result?.player_details?.userId;
          const userRefCode = res?.data?.result?.player_details?.userRefCode;
          dispatch(getUserLoyalty(loyaltyUserId, userRefCode));
        }

        if (from !== "pin_validation") {
          setToLocalStorage("gk", res?.data?.result?.accessToken);
          dispatch(setToken(res?.data?.result?.accessToken));
          dispatch(setPin(pin));
          dispatch(setPlayerDetails(playerDetails));
          dispatch(getUserDetails());
          dispatch(setIsmodalOpen(false));
          trackEvent("User", "Login", "Completed");
        }

        if (from !== "pin_validation" && navigate) {
          navigate("/");
        }
      } else {
        dispatch(setIsLoading(false));
        dispatch(setSignInSuccess(false));
        const userId = mobNum;
        trackLoginSuccessEvent(userId, "unknown", "failed");
        const errorMsg = res?.data?.result?.message;
        if (errorMsg == "INVALID_USER_NAME") {
          if (from === "pin_validation") {
            dispatch(setErrorMessage("Invalid mobile number"));
          } else {
            dispatch(
              setErrorMessage(
                " User doesn't exist, please enter a registered mobile number or Sign Up"
              )
            );
          }
        } else if (errorMsg == "INVALID_PASSWORD") {
          dispatch(setErrorMessage("please enter a Valid 4 digit PIN"));
        }
        else if (errorMsg == "PLAYER_ACCOUNT_SELF_EXCLUDED") {
          dispatch(setErrorMessage("Your account is self-excluded, and betting is currently unavailable."));
        }
        else {
          dispatch(setErrorMessage(errorMsg));
        }
      }
    })
    .catch((err) => {
      dispatch(setIsLoading(false));
      dispatch(setSignInSuccess(false));
      dispatch(setErrorMessage("An error occurred during sign in"));
    });
};

export const selfexclusion = (selfExclusionDateRange) => async (dispatch) => {
  let url = endpoints?.selfexclusion;
  const token = getFromLocalStorage("gk");
  const payload = {
    accessToken: token,
    ...selfExclusionDateRange,
  };

  try {
    const res = await postRequest(url, payload);

    // Handle 401 Unauthorized
    if (res?.data?.result?.code === 401 || res?.data?.code === 401) {
      dispatch(setSessionActive(false));
      dispatch(handleLogout(token));
      removeFromLocalStorage("gk");
      unSubscribeUserBalance(token);
      const error = new Error("INVALID_TOKEN_OR_EXPIRED");
      error.statusCode = 401;
    }

    if (res?.data?.code === "1000" && res?.data?.result?.status === 200) {
      dispatch(setSelfExclusion(res?.data?.result?.data));
      dispatch(setSelfExclusionError(""));
      return { success: true, data: res?.data?.result?.data };
    } else {
      const errorMessage = res?.data?.result?.message || "USERLIMITS_UPDATE_ERROR";
      dispatch(setSelfExclusion({}));
      dispatch(setSelfExclusionError(errorMessage));
      const error = new Error(errorMessage);
      error.errorCode = errorMessage;
      return { success: false, data:  errorMessage };
    }
  } catch (err) {
    // Handle 401 in catch block as well
    if (err?.statusCode === 401 || err?.status === 401) {
      dispatch(setSessionActive(false));
      dispatch(handleLogout(token));
      removeFromLocalStorage("gk");
      unSubscribeUserBalance(token);
      throw err;
    }

    const errorMessage = err?.errorCode || err?.message || "An error occurred while updating limit";
    console.error("Error in selfexclusion API call:", err);
    dispatch(setSelfExclusion({}));
    dispatch(setSelfExclusionError(errorMessage));
    throw new Error(errorMessage);
  }
};

export const getUserDetails = () => (dispatch) => {
  let url = endpoints?.userDetails;

  const token = getFromLocalStorage("gk");
  const payload = {
    accessToken: token,
    clientType: "mobile",
  };
  postRequest(url, payload).then((res) => {
    if (res?.status === 200) {
      if (res?.data?.statusCode === 401) {
        dispatch(setSessionActive(false));
        dispatch(handleLogout(token));
        unSubscribeUserBalance(token);
      } else {
        dispatch(setSessionActive(true));
        dispatch(setUserDetails(res?.data?.result));
        dispatch(getRealBalance());
        subscribeUserBalance(token);
      }
    } else {
      dispatch(setSessionActive(false));
      dispatch(handleLogout(token));
    }
  });
};

export const getRealBalance = () => (dispatch) => {
  const token = getFromLocalStorage("gk");
  let url = endpoints?.realBalance;
  const payload = {
    accessToken: token,
  };
  postRequest(url, payload).then((res) => {
    if (res?.status === 200) {
      if (res?.data?.real_balance?.statusCode === 401) {
        dispatch(setSessionActive(false));
        dispatch(handleLogout(token));
      } else {
        dispatch(setBalance(res?.data?.total_balance));
        dispatch(setBalanceDetails(res?.data));
      }
    }
  });
};

export const getUpdateLoyalty = (userId) => (dispatch) => {
  const url = endpoints?.loyalty;
  const payload = {
    operatorId: "fasfas",
    platformId: 1,
    brand: "fasfas",
    userId: `${userId}`,
    amount: 10,
    bonusType: "coins",
    loyaltyType: "signup",
  };

  const headers = new Headers();
  headers.append(
    "Authorization",
    "Basic " +
      btoa(endpoints?.loyaltyUsername + ":" + endpoints?.loyaltyPassword)
  );
  headers.append("Content-Type", "application/json");

  fetch(url, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(payload),
  })
    .then((res) => {
      if (res.status === 200) {
        trackEvent("User", "loyalty coins", "updated");
        dispatch(setUpdateLoyalty(true));
      } else {
        dispatch(setUpdateLoyalty(false));
      }
    })
    .catch((error) => {
      // Handle error
    });
};

export const getUserLoyalty = (userId) => (dispatch) => {
  const url = endpoints?.userLoyalty;
  const payload = {
    operatorId: "fasfas",
    platformId: 1,
    brand: "fasfas",
    userId: `${userId}`,
  };

  const headers = new Headers();
  headers.append(
    "Authorization",
    "Basic " +
      btoa(endpoints?.loyaltyUsername + ":" + endpoints?.loyaltyPassword)
  );
  headers.append("Content-Type", "application/json");

  fetch(url, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(payload),
  })
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        throw new Error("Failed to fetch data");
      }
    })
    .then((data) => {
      dispatch(setUserLoyalty(data.result));
    })
    .catch((error) => {
      console.error("Error:", error);
      dispatch(setUserLoyalty(0));
    });
};

export const redeemCoins =
  (
    userId,
    coins,
    token,
    phoneNumber,
    currency,
    bonus_type,
    coinsValue,
    secretKey
  ) =>
  (dispatch) => {
    const num = parseInt(coins);
    const url = endpoints?.redeemCoins;
    const payload = {
      operatorId: "fasfas",
      platformId: 1,
      brand: "fasfas",
      userId: `${userId}`,
      coins: num,
      loyaltyType: "burn",
      token: token,
    };
    const headers = new Headers();
    headers.append(
      "Authorization",
      "Basic " +
        btoa(endpoints?.loyaltyUsername + ":" + endpoints?.loyaltyPassword)
    );
    headers.append("Content-Type", "application/json");

    dispatch(setIsApiCall(true));
    fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(payload),
    })
      .then((res) => {
        if (res.status === 200 || res.status === 400) {
          return res.json();
        } else {
          throw new Error("Failed to fetch data");
        }
      })
      .then((data) => {
        dispatch(setIsApiCall(false));
        dispatch(setBurnCoinsData(data));
        dispatch(getUserLoyalty(userId));
        dispatch(setErrorMessage(data?.message));
        trackEvent("User", "reedem coins", "updated");
        dispatch(getUserDetails(userId));
        dispatch(coinsHistory(userId));
        
        trackBonusClaimEvent(
          phoneNumber,
          "loyalty_burn",
          coinsValue,
          currency,
          "existing",
          data?.amount,
          secretKey,
        );
        
        setInterval(() => {
          dispatch(setErrorMessage(""));
        }, 3000);
      })
      .catch((error) => {
        dispatch(setIsApiCall(false));
        dispatch(setErrorMessage(error));
        dispatch(setBurnCoinsData([]));
      });
  };

export const coinsHistory = (userId) => (dispatch) => {
  const url = endpoints?.coinsHistory;
  const payload = {
    operatorId: "fasfas",
    platformId: 1,
    brand: "fasfas",
    userId: `${userId}`,
  };
  const headers = new Headers();
  headers.append(
    "Authorization",
    "Basic " +
      btoa(endpoints?.loyaltyUsername + ":" + endpoints?.loyaltyPassword)
  );
  headers.append("Content-Type", "application/json");

  fetch(url, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(payload),
  })
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        throw new Error("Failed to fetch data");
      }
    })
    .then((data) => {
      const coinsInfo = data?.result?.data;
      const filteredData = coinsInfo.filter(
        (item) => item?.transactionType !== "credit"
      );
      const totalCoins = filteredData.reduce(
        (total, item) => total + item.coinsDebit,
        0
      );
      dispatch(setLifeTimeBurns(totalCoins));
      const creditData = coinsInfo.filter(
        (item) => item?.transactionType !== "debit"
      );
      const totalCoinsCredited = filteredData.reduce(
        (total, item) => total + item.amount,
        0
      );
      dispatch(setLifeTimeCashBack(totalCoinsCredited));
    })
    .catch((error) => {
      console.error("Error:", error);
    });
};

export const paymentConfig = () => (dispatch) => {
  let url = endpoints?.paymentConfig;
  const token = getFromLocalStorage("gk");
  const payload = {
    accessToken: token,
    clientType: "mobile",
  };
  postRequest(url, payload).then((res) => {
    if (res.status === 200) {
      dispatch(setConfigApiDetails(res?.data?.result?.data));
    } else {
      dispatch(setConfigApiDetails([]));
    }
  });
};
